module.exports = __webpack_public_path__ + "static/media/sweet_view_2.c15de86c.jpg";